import readXlsxFile from 'read-excel-file';


let date = new Date();
const currentDayOfMonth = date.getDate();
const currentMonth = date.getMonth(); // Be careful! January is 0, not 1
const currentYear = date.getFullYear();

let product, dataType = null;

const dateString = currentDayOfMonth + "-" + (currentMonth + 1) + "-" + currentYear;

function arrayEquals(a, b) {
  return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
}

let errorLogArray = {
	Microbiology:[],
	Nutritional:[],
};


const productNameTest = async (data,sheet) => {

	let dataAux = data;
	let batchID = null;
	let finalDataArray = [];
	let errorFound = false;

	finalDataArray.push(dataAux[0]);

	for(let i = 1 ; i < dataAux.length; i++){

		if(dataAux[i][0] != product){
				
				errorFound = true;
				batchID = dataAux[i][1];

				//filter the wrong entries
				for(let j = 1; j < dataAux.length; j++){

					if(batchID == dataAux[j][1]){

					}
					else{

						finalDataArray.push(dataAux[j]);
					}

				}

				let errorMsg =  'Deleted entries with BatchID: ' + batchID +'. ' + 'Error: wrong product name.\n';

				errorLogArray[sheet].push(errorMsg);


		}
		else{

		}

	}

	if(errorFound == false){
		 finalDataArray = dataAux;
	}

	return finalDataArray;
}

//Iterates the data to check for errors
//If an error is found all the lines of the same batchID are removed
//Returns the modified array
const runErrorTests = async (data,sheet) =>{

	let res = await productNameTest(data,sheet);	

	return res;
}


const errorCheck = async (Microbiology,Nutritional) =>{

	let [microArray, nutriArray] = await Promise.all([runErrorTests(Microbiology, 'Microbiology'),runErrorTests(Nutritional, 'Nutritional')]);

	let resArrays = {
		microbiology: microArray,
		nutritional: nutriArray
	}

	return resArrays;

}


const meanTypeReader = (companyName,reader_microbiology, reader_nutritional) =>{


	let res = {
		status: null,
		data: null
	}


	let meanMicroHeader = [
		"Product", //0
		"Batch", //1
		"Batch size", //2
		"Number of Samples", //3
		"Trial", //4
		"Production date", //5
		"Bacteria", //6
		"Mean", //7
		"Minimum", //8
		"Maximum", //9
		"Bacteria Detection",//10
	  	"Positive Samples",//11
	];

	let meanNutriHeader = [

		"Product",//0
		"Batch",//1
		"Batch size",//2
		"Number of samples", //3
		"Trial", //4
		"Production date",//5
		"Property", //6
		"Mean", //7
		"Standard deviation" //8
	]

	//Verify if header file matches the header layout
	let batchData = [];
	let nutriBatchData = [];
	let batchID = '';
	let nutriBatchID = '';

	let areMicroHeadersEqual = arrayEquals(meanMicroHeader, reader_microbiology[0]);

	let areNutriHeadersEqual = arrayEquals(meanNutriHeader, reader_nutritional[0]);

	if(areMicroHeadersEqual && areNutriHeadersEqual){
		
		let batchItem = {};
		//iterate each table row for microbiology data
		for(let rowIndex = 1; rowIndex < reader_microbiology.length ; rowIndex++){

				let row = reader_microbiology[rowIndex];

				

				//new batchID
				if(batchID != row[1]){

					console.log(row);

					if(Object.keys(batchItem).length != 0){
						//obj has keys
						//push obj to batchData Array
						batchData.push(batchItem);
						batchItem = {};
					}

					//clean obj
					
					//attribute new batchID
					batchID = row[1];

					batchItem.Company = companyName;
					batchItem.Product = row[0];
					
					batchItem.BatchID = row[1];
					batchItem.BatchSize = row[2];
					batchItem.NumberOfSamples = row[3];
					batchItem.Trial = row[4];
					batchItem.ProductionDate = new Date(row[5]).toLocaleDateString();
					batchItem.InsertionDate = date.toLocaleDateString();
					batchItem.DataType = 'Mean';
					batchItem.Samples = [];

					let sampleAux = {
						Microbiology:{},
						Nutritional:{}
					}

					batchItem.Samples.push(sampleAux);

					if(row[6] == 'None'){
						batchItem.Samples[0].Microbiology[row[10]] = row[11];
					}	
					else{
						batchItem.Samples[0].Microbiology[row[6]] = row[7];
						batchItem.Samples[0].Microbiology[row[6] + '_Min'] = row[8];
						batchItem.Samples[0].Microbiology[row[6] + '_Max'] = row[9];	
					}
					
				}
				else{

					if(row[6] == 'None'){
						batchItem.Samples[0].Microbiology[row[10]] = row[11];
					}	
					else{
						batchItem.Samples[0].Microbiology[row[6]] = row[7];
						batchItem.Samples[0].Microbiology[row[6] + '_Min'] = row[8];
						batchItem.Samples[0].Microbiology[row[6] + '_Max'] = row[9];	
					}

					if((rowIndex +1) == reader_microbiology.length ){
						batchData.push(batchItem);
						batchItem = {};
						batchID = '';

					}

				}
				
		}

		console.log('****',batchData,'****');

		let nutriBatchItem = {};
		//iterate each table row for nutritional data
		for(let rowIndex = 1; rowIndex < reader_nutritional.length; rowIndex++){

				let row = reader_nutritional[rowIndex];


				//new batchID
				if(nutriBatchID != row[1]){


					if(Object.keys(nutriBatchItem).length != 0){
						//obj has keys
						//push obj to batchData Array
						nutriBatchData.push(nutriBatchItem);
						nutriBatchItem = {};
					}

					//clean obj
					
					//attribute new batchID
					nutriBatchID = row[1];

					nutriBatchItem.Company = companyName;
					nutriBatchItem.Product = row[0];
					
					nutriBatchItem.BatchID = row[1];
					nutriBatchItem.BatchSize = row[2];
					nutriBatchItem.NumberOfSamples = row[3];
					nutriBatchItem.Trial = row[4];
					nutriBatchItem.ProductionDate = new Date(row[5]).toLocaleDateString();
					nutriBatchItem.InsertionDate = date.toLocaleDateString();
					nutriBatchItem.DataType = 'Mean';
					nutriBatchItem.Samples = [];

					let sampleAux = {
						Microbiology:{},
						Nutritional:{}
					}

					nutriBatchItem.Samples.push(sampleAux);	
					nutriBatchItem.Samples[0].Nutritional[row[6]] = row[7];
					nutriBatchItem.Samples[0].Nutritional[row[6] + '_Std'] = row[8];

				}
				else{

					nutriBatchItem.Samples[0].Nutritional[row[6]] = row[7];
					nutriBatchItem.Samples[0].Nutritional[row[6] + '_Std'] = row[8];

					if((rowIndex +1) == reader_nutritional.length ){

						nutriBatchData.push(nutriBatchItem);

						
					}

				}
		}	

		console.log('****',nutriBatchData,'****');
		

		//join the two arrays
		for(let microObjIndex = 0; microObjIndex < batchData.length ; microObjIndex++){

			let microObj = batchData[microObjIndex];
			let microBatchID = microObj.BatchID;

			for(let nutriObjIndex = 0 ; nutriObjIndex < nutriBatchData.length;  nutriObjIndex++){

				let nutriObj = nutriBatchData[nutriObjIndex];
				// let nutriBatchID = nutriObj.BatchID;
				let nutriBatchID_aux = nutriObj.BatchID;

				// console.log(nutriObj);

				if(microBatchID == nutriBatchID_aux){

						batchData[microObjIndex].Samples[0].Nutritional = nutriBatchData[nutriObjIndex].Samples[0].Nutritional;
						nutriBatchData.splice(nutriObjIndex, 1);
						break;
				}
			}
		}

		console.log('****',batchData,'****');

		//Still has items to add to batch Data
		if(nutriBatchData != 0 ){

				for(let nutriObjIndex = 0; nutriObjIndex < nutriBatchData.length ; nutriObjIndex++ ){

						batchData.push(nutriBatchData[nutriObjIndex]);
						nutriBatchData.splice(nutriObjIndex, 1);
				}
		}
		else{
			//do nothing
		}

		res.status = 'valid';
		res.data = batchData;

		return res;

	}
	else{

		res.status = 'error';
		return res;
	}

}


const individualTypeReader = (companyName,reader_microbiology, reader_nutritional) =>{

	let res = {
		status: null,
		data: null
	}


	let meanMicroHeader = [
	  "Product",//0
	  "Batch",//1
	  "Batch size",//2
	  "Number of samples",//3
	  "Sample number",//4
	  "Trial",//5
	  "Production date",//6
	  "Bacteria",//7
	  "Value",//8
	  "Bacteria Detection",//9
	  "Detected",//10
	];

	let meanNutriHeader = [
	  "Product",//0
	  "Batch",//1
	  "Batch size",//2
	  "Number of samples",//3
	  "Sample number",//4
	  "Trial",//5
	  "Production date",//6
	  "Property",//7
	  "Value"//8
	]

	//Verify if header file matches the header layout

	let batchData = [];
	let nutriBatchData = [];
	let batchID = '';
	let nutriBatchID = '';

	let areMicroHeadersEqual = arrayEquals(meanMicroHeader, reader_microbiology[0]);

	let areNutriHeadersEqual = arrayEquals(meanNutriHeader, reader_nutritional[0]);

	if(areMicroHeadersEqual && areNutriHeadersEqual){

		let batchItem = {};
		let sampleNumber = null;
		//iterate each table row for microbiology data
		for(let rowIndex = 1; rowIndex < reader_microbiology.length ; rowIndex++){

				let row = reader_microbiology[rowIndex];


				//new batchID
				if(batchID != row[1]){


					if(Object.keys(batchItem).length != 0){
						//obj has keys
						//push obj to batchData Array
						batchData.push(batchItem);
						batchItem = {};
					}

					//clean obj
					
					//attribute new batchID
					batchID = row[1];

					batchItem.Company = companyName;
					batchItem.Product = row[0];
					batchItem.BatchID = row[1];
					batchItem.BatchSize = row[2];
					batchItem.NumberOfSamples = row[3];

					sampleNumber = row[4];

					batchItem.Trial = row[5];
					batchItem.ProductionDate = new Date(row[6]).toLocaleDateString();
					batchItem.InsertionDate = date.toLocaleDateString();
					batchItem.DataType = 'Individual';
					batchItem.Samples = [];

					for(let i = 0; i < batchItem.NumberOfSamples ; i++){
							var sampleAux = {
								Microbiology:{},
								Nutritional:{},
								SampleID: i+1
							}
							batchItem.Samples.push(sampleAux);							
					} 

					//new changes
					if(row[7] == 'None'){
						batchItem.Samples[sampleNumber-1].Microbiology[row[9]] = row[10];
					}
					else{
						batchItem.Samples[sampleNumber-1].Microbiology[row[7]] = row[8];
					}
					

				}
				else{

					sampleNumber = row[4];

					//new changes
					if(row[7] == 'None'){
						batchItem.Samples[sampleNumber-1].Microbiology[row[9]] = row[10];
					}
					else{
						batchItem.Samples[sampleNumber-1].Microbiology[row[7]] = row[8];
					}

					if((rowIndex +1) == reader_microbiology.length ){
						batchData.push(batchItem);
						batchItem = {};
						batchID = '';
					}

				}
				
		}

		var nutriBatchItem = {};
		//iterate each table row for nutritional data
		for(let rowIndex = 1; rowIndex < reader_nutritional.length ; rowIndex++){

				let row = reader_nutritional[rowIndex];


				//new batchID
				if(nutriBatchID != row[1]){


					if(Object.keys(nutriBatchItem).length != 0){
						//obj has keys
						//push obj to batchData Array
						nutriBatchData.push(nutriBatchItem);
						nutriBatchItem = {};
					}

					//clean obj
					
					//attribute new batchID
					nutriBatchID = row[1];

					nutriBatchItem.Company = companyName;
					nutriBatchItem.Product = row[0];
					nutriBatchItem.BatchID = row[1];
					nutriBatchItem.BatchSize = row[2];
					nutriBatchItem.NumberOfSamples = row[3];

					sampleNumber = row[4];

					nutriBatchItem.Trial = row[5];
					nutriBatchItem.ProductionDate = new Date(row[6]).toLocaleDateString();
					nutriBatchItem.InsertionDate = date.toLocaleDateString();
					nutriBatchItem.DataType = 'Individual';
					nutriBatchItem.Samples = [];

					for(let i = 0; i < nutriBatchItem.NumberOfSamples ; i++){
							var sampleAux = {
								Microbiology:{},
								Nutritional:{},
								SampleID: i+1
							}
							nutriBatchItem.Samples.push(sampleAux);							
					} 

					nutriBatchItem.Samples[sampleNumber-1].Nutritional[row[7]] = row[8];

				}
				else{

					sampleNumber = row[4];

					nutriBatchItem.Samples[sampleNumber-1].Nutritional[row[7]] = row[8];

					if((rowIndex +1) == reader_nutritional.length ){
						nutriBatchData.push(nutriBatchItem);
						nutriBatchItem = {};
						nutriBatchID = '';
					}

				}
				
		}


		//join the two arrays
		for(let microObjIndex = 0; microObjIndex < batchData.length ; microObjIndex++){

			let microObj = batchData[microObjIndex];
			let microBatchID = microObj.BatchID;

			for(let nutriObjIndex = 0 ; nutriObjIndex < nutriBatchData.length;  nutriObjIndex++){

				let nutriObj = nutriBatchData[nutriObjIndex];
				let nutriBatchID = nutriObj.BatchID;
				nutriBatchID = nutriObj.BatchID;

				if(microBatchID == nutriBatchID){


						for(let i = 0 ; i < batchData[microObjIndex].NumberOfSamples; i++ ){

							batchData[microObjIndex].Samples[i].Nutritional = nutriBatchData[nutriObjIndex].Samples[i].Nutritional;	

						}
						
						nutriBatchData.splice(nutriObjIndex, 1);
						break;
				}
				else{
					continue;
				}
			}
		}


		//Still has items to add to batch Data
		if(nutriBatchData != 0 ){

				for(let nutriObjIndex = 0; nutriObjIndex < nutriBatchData.length ; nutriObjIndex++ ){

						batchData.push(nutriBatchData[nutriObjIndex]);
						nutriBatchData.splice(nutriObjIndex, 1);
				}
		}
		else{
			//do nothing
		}

		// console.log(batchData);

		// console.log(nutriBatchData);
		res.status = 'valid';
		res.data = batchData;

		return res;

	}
	else{
		res.status = 'error';
		return res;
	}
	
}

export const readExcelFile = async (file, data) => {

	let res = {
      status: null
    }

  product = data.product;
  dataType = data.dataType;
	try{
		
		const reader_microbiology = await readXlsxFile(file, { sheet: 'Microbiology' });

		const reader_nutritional = await readXlsxFile(file, { sheet: 'Physicochemical' });

		let batchData = [];

		let user = localStorage.getItem('user');

		let companyName = null; 

		user =  JSON.parse(user);
		companyName = user.company;	


		if(dataType == 'Mean'){

			// let resErrorCheck = await errorCheck(reader_microbiology, reader_nutritional );

			// const meanRes  = await meanTypeReader(companyName,resErrorCheck.microbiology,resErrorCheck.nutritional);

			const meanRes  = await meanTypeReader(companyName,reader_microbiology,reader_nutritional);

			res.status = meanRes.status;
			res.data = meanRes.data;
			res.errorLog = errorLogArray;


		}
		else if(dataType == 'Individual'){

			// let resErrorCheck = await errorCheck(reader_microbiology, reader_nutritional);

			const individualRes = await individualTypeReader(companyName,reader_microbiology,reader_nutritional);
			console.log('individualRes', individualRes);

			res.status = individualRes.status;
			res.data =  individualRes.data;
			res.errorLog = errorLogArray;


		}
		else{

			//error
		}

		 return res;
	}
	catch(error){

		 res.status = "error";
		 res.error = error;
		 return res;

	}
	
}

